export const EndorsementDocuments = {
  ACTIVE_LIST: "active_list",
  ANNEXURE: "annexure",
  CD_STATEMENT: "cd_statement",
  ENDORSEMENT_COPY: "endorsement_copy",
  TAX_INVOICE: "tax_invoice",
};
